<script setup>
import {ref} from "vue";
import AgencyWebsiteFormStep1 from "@/components/website/AgencyWebsiteFormStep1.vue";
import AgencyWebsiteFormStep2 from "@/components/website/AgencyWebsiteFormStep2.vue";
import AgencyWebsiteFormStep3 from "@/components/website/AgencyWebsiteFormStep3.vue";

defineProps({
  countries: {
    required: true,
    type: Object,
  },
  industries: {
    required: true,
    type: Object,
  },
  freeWebsite: {
    required: true,
    type: Boolean,
  },
  softwarePrice: {
    required: true,
    type: Object,
  },
});

const currentStep = ref(1);

const handleNext = () => currentStep.value++;
const handleBack = () => currentStep.value--;
</script>

<template>
  <AgencyWebsiteFormStep1
    v-if="currentStep === 1"
    @next="handleNext"
  />

  <AgencyWebsiteFormStep2
    v-else-if="currentStep === 2"
    :countries="countries"
    :industries="industries"
    :free-website="freeWebsite"
    :software-price="softwarePrice"
    @next="handleNext"
    @back="handleBack"
  />

  <AgencyWebsiteFormStep3
    v-else-if="currentStep === 3"
    @back="handleBack"
  />
</template>
